import SeminarOverview, { SeminarOverviewProps } from './SeminarOverview.component';

export type SeminarOverviewType = SeminarOverviewProps;

export default SeminarOverview;
